import { allEventOptions } from 'config/admin/meet';
import { TRACK_EVENTS_CODE } from 'constants/eventTypes';

export const RoleCategory = Object.freeze({
  General: 'General',
  AgeGroupSpecific: 'AgeGroupSpecific',
  EventSpecific: 'EventSpecific',
});

export const ROLE_CATEGORY_OPTIONS = [
  { value: RoleCategory.General, label: 'General' },
  { value: RoleCategory.AgeGroupSpecific, label: 'Age Group' },
  { value: RoleCategory.EventSpecific, label: 'Event' },
];

// The role categories as the selected club reads them: the Age Group category
// is "Year Group" for a club that groups by year level. words comes from
// groupWords (utils/groupLabel.js). The stored value is the same for both.
export const getRoleCategoryOptions = (words) =>
  ROLE_CATEGORY_OPTIONS.map((option) =>
    option.value === RoleCategory.AgeGroupSpecific
      ? { ...option, label: words.group }
      : option
  );

// Field events a volunteer role can map to (matched literally by event
// code — track roles use the TRACK_EVENTS_CODE sentinel instead of real
// track codes). Display-only variants like Floppy Jump belong here even
// though they are not in allEventOptions; extend this list when a new
// mappable event type is added to the system.
export const VOLUNTEER_FIELD_EVENT_OPTIONS = [
  { value: 61, label: 'High Jump' },
  { value: 62, label: 'Long Jump' },
  { value: 63, label: 'Triple Jump' },
  { value: 64, label: 'Discus' },
  { value: 65, label: 'Javelin' },
  { value: 66, label: 'Shot Put' },
  { value: 67, label: 'Floppy Jump' },
];

// Display label for a volunteer role's mapped event code. Falls back to
// allEventOptions for legacy roles mapped to individual track codes, then
// to the raw code.
export const getVolunteerEventTypeLabel = (code) => {
  if (+code === TRACK_EVENTS_CODE) return 'Track Events';
  const opt =
    VOLUNTEER_FIELD_EVENT_OPTIONS.find((o) => o.value === +code) ||
    allEventOptions.find((o) => +o.value === +code);
  return opt?.label || String(code);
};

export const ROLE_AGE_GROUP_OPTIONS = [
  'U5',
  'U6',
  'U7',
  'U8',
  'U9',
  'U10',
  'U11',
  'U12',
  'U13',
  'U14-U17',
].map((opt) => ({ value: opt, label: opt }));
